function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#181C20",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#343D44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 9A5 5 0 117 9a5 5 0 0110 0zM4 24a8 8 0 1116 0H4z"
}));

var SvgEmptyAvatar = function SvgEmptyAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkF2YXRhciBlbXB0eSI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzE4MUMyMCIvPgo8ZyBpZD0iVmVjdG9yIj4KPHBhdGggZD0iTTE3IDlDMTcgMTEuNzYxNCAxNC43NjE0IDE0IDEyIDE0QzkuMjM4NTggMTQgNyAxMS43NjE0IDcgOUM3IDYuMjM4NTggOS4yMzg1OCA0IDEyIDRDMTQuNzYxNCA0IDE3IDYuMjM4NTggMTcgOVoiIGZpbGw9IiMzNDNENDQiLz4KPHBhdGggZD0iTTQgMjRDNCAxOS41ODE3IDcuNTgxNzIgMTYgMTIgMTZDMTYuNDE4MyAxNiAyMCAxOS41ODE3IDIwIDI0SDRaIiBmaWxsPSIjMzQzRDQ0Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgEmptyAvatar as ReactComponent };